import { Component, OnInit } from '@angular/core';

import { Location } from "app/common/location";
import { ActivatedRoute } from '@angular/router';
import { CaseService } from 'app/case/case.service';
import { Subscribable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';
import { GUID } from 'app/brightserve/brightserve.module';

@Component({
	selector: 'app-case-details-media',
	templateUrl: './case-details-media.component.html',
	styleUrls: ['./case-details-media.component.css']
})
export class CaseDetailsMediaComponent implements OnInit {

	ViewLocation: boolean = false;
	Location: Location = new Location({ Name: "default" });

	MediaDisplay: string = "Grid";
	Media: Array<any> = [];

    sub: Subscription;
    IncidentId: GUID;
    ClientId: GUID;

    constructor(private caseService: CaseService, private route: ActivatedRoute) { }

    ngOnInit() {
        this.sub = this.route.parent.params.subscribe(params => {
            if (params && params['id']) {
                this.IncidentId = params['id'];
                this.GetThumbnails();
            }
        });
    };

    GetThumbnails() {
        this.caseService.ListMediaItem(this.IncidentId).subscribe((res) => {
            this.ClientId = res.ClientId;
            this.Media = res.MediaItems;
            console.log(this.Media);
        }, (err) => {

        });
    };

	ToggleDisplay(type) {
		if (type == "List") {
			var _this = this;
			_this.MediaDisplay = "List";
		} else {
			this.MediaDisplay = "Grid";
		};
    };

    GetFilePath(item) {
        var path = "/sync/" + this.ClientId + "/";

        if (item.Type.Value == "Photo")
            return path + "photos/" + item.Filename;

        if (item.Type.Value == "Photo")
            return path + "videos/" + item.Filename;

        return "";
    }
}



// WEBPACK FOOTER //
// ./src/app/case/details/media/case-details-media.component.ts